<template>
    <el-table v-loading="messages.length === 0" :data="messages" height="740"
              :default-sort="{prop: 'timestamp', order: 'descending'}">
        <el-table-column min-width="180" label="Player">
            <template slot-scope="scope">
                <vue-plyr
                    :options="{'controls': [ 'play','progress','current-time','download']}">
                    <audio preload="none">
                        <source :src="scope.row.file" type="audio/wav"/>
                    </audio>
                </vue-plyr>
            </template>

        </el-table-column>
        <el-table-column min-width="80" label="Temporary">
            <template slot-scope="scope">
                {{ scope.row.temporary ? 'Yes' : 'No' }}
            </template>
        </el-table-column>
        <el-table-column min-width="95" label="Category">
            <template slot-scope="scope">
                <span v-if="scope.row.category === 'lessons'"
                      class="badge badge-success">{{ scope.row.category }}</span>
                <span v-if="scope.row.category === 'teacher'" class="badge badge-info">{{ scope.row.category }}</span>
                <span v-if="scope.row.category === 'other'" class="badge badge-default">{{ scope.row.category }}</span>
                <span v-if="scope.row.category === 'chol'" class="badge badge-warning">{{ scope.row.category }}</span>
            </template>
        </el-table-column>
        <el-table-column min-width="95" prop="timestamp" sortable label="Date">
            <template slot-scope="scope">
                {{ moment.unix(scope.row.timestamp).calendar() }}
            </template>

        </el-table-column>
        <el-table-column
            header-align="right"
            align="right"
            min-width="70"
            label="Actions">
            <div slot-scope="{ row,$index}" class="text-right table-actions">
            </div>
        </el-table-column>
    </el-table>
</template>
<script>
    import axios from "axios";
    import swal from "sweetalert2";

    export default {
        name: 'old_files-table',
        props: {
            classroom: {}
        },
        data() {
            return {
                messages: [],
                restoring: [],
                loading: true,

            };
        },
        mounted() {
            this.loadMessages();
        },
        methods: {
            loadMessages() {
                this.loading = true;
                axios({
                    url: this.baseAPIURL + 'classroom/' + this.classroom.id + '/old', method: 'GET', headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                    },
                }).then(resp => {
                    this.messages = resp.data.data;
                }).finally(() => {
                    this.$forceUpdate();
                    this.loading = false;
                });
            },
        }
    }
</script>
<style>
    .white-content .el-table table > tbody > tr > td {
        padding: 4px 2px;
    }

</style>
